import { useArray } from "./useArray";

export function useToggleArray(initialState: boolean[]) {
    const { array, set, update, push, remove, clear } = useArray(initialState)

    function toggleAll() {
        set(curr => curr.map((i) => !i))
    }

    function toggleState(idx: number) {
        update(idx, (s) => !s)
    }

    function itemState(idx: number) {
        if (idx > array.length - 1 || idx < 0) return
        return array[idx]
    }

    function setAll(state: boolean) {
        set((curr) => Array(curr.length).fill(state))
    }


    return {
        array,
        toggleItem: toggleState,
        toggleAll,
        itemState,
        setAll,
        push,
        remove,
        clear,
    };

}
